export enum EmailVerificationErrorTypes {
	EMAIL_USED = 'Email Already Used',
	INCORRECT_CODE = 'Incorrect Code',
	MAX_ATTEMPT = 'Max Attempts Reached',
	MISSING_VERIFICATION = 'Missing Verification'
}
